import { render, staticRenderFns } from "./DashboardPendenciasPlanejamento.vue?vue&type=template&id=868cc4ec"
import script from "./DashboardPendenciasPlanejamento.vue?vue&type=script&lang=js"
export * from "./DashboardPendenciasPlanejamento.vue?vue&type=script&lang=js"
import style0 from "./DashboardPendenciasPlanejamento.vue?vue&type=style&index=0&id=868cc4ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports